<template>
  <div class="staff-contribution-input clearfix">
    <div v-if="!hide" class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <div class='col-sm-12'>
        <div class='row'>
          <div class='col-sm-12'>
            <template v-for="(section, index) in sections"> 
              <staff-contribution-item-input
                :key="index" :onChange="validate" :options="section" v-model="section.value" ref="fields"
              ></staff-contribution-item-input>
            </template>
          </div>
        </div>
        <div class="row">
          <div class='col-sm-9 offset-sm-3'>
            <span :class="validationClass" v-show="validationMessage">
              {{ validationMessage }}
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-9 offset-sm-3">
            <button
              class="my-1 btn btn-success"
              @click="addStaff()"
              type="button">
              <i class="fas fa-plus" /> Add Staff
            </button>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'
import StaffContributionItemInput from '@/components/inputs/StaffContributionItemInput'

export default {
  name: 'StaffContributionInput',
  components: {
    StaffContributionItemInput
  },
  props: {
    value: {
      type: [Array]
    },
    options: {
      type: Object,
      default () {
        return {
          label: ''
        }
      }
    }
  },
  data () {
    return {
      isValid: true,
      isDirty: false,
      watcher: false,
      hide: false,
      sections: [],
      doesNotSumToTotal: false,
      nullValueExist: false,
      idStart: 0
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      if (this.doesNotSumToTotal) {
        return 'Total does not add up to 100%'
      }
    }
  },
  mounted () {
    this.value.forEach(val => {
      this.sections.push({
        value: val,
        existing: this.options.existingStaff,
        required: true,
        label: 'Staff',
        name: 'name',
        id: this.idStart,
        removeItem: this.removeStaff,
        itemState: this.itemState,
        isValid: false
      })
      this.idStart++
    })
    if (this.options.hidden) this.hide = true
    this.validate()
  },
  methods: {
    removeStaff (id) {
      this.sections = this.sections.filter(section => section.id !== id)
      this.validate()
    },
    addStaff () {
      this.sections.push({
        value: {
          contribution: '',
          reportHours: '',
          siteHours: '',
          eUuid: ''
        },
        existing: this.options.existingStaff,
        required: true,
        label: 'Staff',
        name: 'name',
        id: this.idStart,
        removeItem: this.removeStaff,
        itemState: this.itemState,
        isValid: false
      })
      this.idStart++
      this.validate()
    },
    itemState (isValid, id) {
      for (let i = 0; i !== this.sections.length; i++) {
        let section = this.sections[i]
        if (section.id === id) {
          this.sections[i].isValid = isValid
          break
        }
      }
    },
    validate (sections = this.sections) {
      let values = []
      if (!this.hide) {
        this.isDirty = true
        let total = 0
        let invalid = false
        for (let section of sections) {
          let val = parseFloat(section.value.contribution)
          values.push(section.value)
          total += val
          if (!section.isValid) {
            invalid = true
            break
          }
        }
        if (total !== 100) {
          this.doesNotSumToTotal = true
          this.isValid = false
        } else if (invalid) {
          this.doesNotSumToTotal = false
          this.isValid = false
        } else {
          this.doesNotSumToTotal = false
          this.isValid = true
          this.sections = [...this.sections]
        }
      } else {
        this.isValid = true
        this.doesNotSumToTotal = false
      }
      this.$emit('input', values)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/inputs/StaffContributionInput.vue